import { parse as parse$1 } from '@louischan-oursky/messageformat-parser';
import * as React from 'react';
import * as Plurals from 'make-plural/plurals';
import { renderToStaticMarkup } from 'react-dom/server';
import { decodeHTML5Strict } from 'entities';

function parse(source) {
  var tokens = parse$1(source, {
    strict: true
  });
  return tokens;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function getComponent(key, components) {
  var c = components[key];

  if (c != null) {
    return c;
  }

  var firstChar = key.slice(0, 1);

  if (firstChar.toLowerCase() === firstChar) {
    // Assume it is HTML tag name.
    return key;
  }

  throw new Error("expected component \"".concat(key, "\" to exist"));
}

function getValue(key, values) {
  if (values == null) {
    throw new Error("expected \"".concat(key, "\" to exist but values is not provided"));
  }

  if (!values.hasOwnProperty(key)) {
    throw new Error("expected \"".concat(key, "\" to exist"));
  }

  var value = values[key];
  return value;
}

function getNumber(key, values) {
  var value = getValue(key, values);

  if (typeof value !== "number") {
    throw new Error("expected \"".concat(key, "\" to be a number"));
  }

  return value;
}

function getString(key, values) {
  var value = getValue(key, values);

  if (typeof value !== "string") {
    throw new Error("expected \"".concat(key, "\" to be a string"));
  }

  return value;
}

function evaluateReactDirective(reactDirective, language, values, components, currentValue) {
  var arg = reactDirective.arg,
      cases = reactDirective.props;
  var component = getComponent(arg, components);
  var props = {};

  var _iterator = _createForOfIteratorHelper(cases),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      var _key = c.key,
          tokens = c.tokens;
      props[_key] = evaluateToInternalValue(tokens, language, values, components, currentValue);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    __kind: "react",
    type: component,
    props: props
  };
}

function resolveSelectCase(select, values) {
  var arg = select.arg,
      cases = select.cases;
  var value = getString(arg, values);
  var targetIndex;
  var otherIndex;

  for (var i = 0; i < cases.length; ++i) {
    var c = cases[i];

    if (c.key === "other") {
      otherIndex = i;
    }

    if (c.key === value) {
      targetIndex = i;
    }
  }

  if (otherIndex === undefined) {
    throw new Error("expected other case");
  }

  if (targetIndex !== undefined) {
    return cases[targetIndex];
  }

  return cases[otherIndex];
}

function resolvePluralFunc(language) {
  var m = Plurals;
  var func = m[language];

  if (func == null) {
    throw new Error("unsupported language: " + language);
  }

  return func;
}

function resolvePluralCase(pluralOrSelectOrdinal, language, values) {
  var type = pluralOrSelectOrdinal.type,
      arg = pluralOrSelectOrdinal.arg,
      offsetString = pluralOrSelectOrdinal.offset,
      cases = pluralOrSelectOrdinal.cases;
  var offset = parseInt(offsetString, 10);

  if (isNaN(offset)) {
    throw new Error("invalid offset");
  }

  var ordinal = type === "selectordinal";
  var pluralFunc = resolvePluralFunc(language);
  var rawValue = getNumber(arg, values);
  var offsetValue = rawValue - offset;
  var pluralRule = pluralFunc(offsetValue, ordinal);
  var valueAsString = String(rawValue);
  var targetIndex;
  var otherIndex;

  for (var i = 0; i < cases.length; ++i) {
    var c = cases[i];

    if (c.key === "other") {
      otherIndex = i;
    }

    if (targetIndex === undefined) {
      if (c.key === valueAsString) {
        targetIndex = i;
      }

      if (c.key === pluralRule) {
        targetIndex = i;
      }
    }
  }

  if (otherIndex === undefined) {
    throw new Error("expected other case");
  }

  if (targetIndex !== undefined) {
    return {
      currentValue: offsetValue,
      pluralCase: cases[targetIndex]
    };
  }

  return {
    currentValue: offsetValue,
    pluralCase: cases[otherIndex]
  };
}

function evaluateToInternalValue(tokens, language, values, components, currentValue) {
  var output = [];

  var _iterator2 = _createForOfIteratorHelper(tokens),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var token = _step2.value;

      if (typeof token === "string") {
        output.push(token);
      } else {
        switch (token.type) {
          case "argument":
            {
              var value = getValue(token.arg, values);
              output.push(value);
              break;
            }

          case "plural":
            {
              var result = resolvePluralCase(token, language, values);
              var nestedTokens = evaluateToInternalValue(result.pluralCase.tokens, language, values, components, result.currentValue);
              output.push(nestedTokens);
              break;
            }

          case "selectordinal":
            {
              var _result = resolvePluralCase(token, language, values);

              var _nestedTokens = evaluateToInternalValue(_result.pluralCase.tokens, language, values, components, _result.currentValue);

              output.push(_nestedTokens);
              break;
            }

          case "react":
            {
              var _result2 = evaluateReactDirective(token, language, values, components, currentValue);

              output.push(_result2);
              break;
            }

          case "select":
            {
              var selectCase = resolveSelectCase(token, values);

              var _nestedTokens2 = evaluateToInternalValue(selectCase.tokens, language, values, components, currentValue);

              output.push(_nestedTokens2);
              break;
            }

          case "octothorpe":
            {
              if (currentValue == null) {
                throw new Error("unexpected #");
              }

              output.push(currentValue);
              break;
            }

          default:
            {
              throw new Error("unexpected type: " + token.type);
            }
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return output;
}

function isReactInternalValue(v) {
  return _typeof(v) === "object" && v.hasOwnProperty("__kind") && v.__kind === "react";
}

function isReactValue(v) {
  return _typeof(v) === "object" && v.hasOwnProperty("__kind") && v.__kind === "react";
}

function flatten(intervalValues) {
  var output = [];

  var _iterator3 = _createForOfIteratorHelper(intervalValues),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var v = _step3.value;

      if (Array.isArray(v)) {
        output.push.apply(output, _toConsumableArray(flatten(v)));
      } else if (isReactInternalValue(v)) {
        var props = v.props;

        for (var _key2 in props) {
          if (props.hasOwnProperty(_key2)) {
            props[_key2] = flatten(props[_key2]);
          }
        }

        output.push(v);
      } else {
        output.push(v);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return output;
}

function collapseValues(values) {
  var shouldCollapseToString = values.every(function (v) {
    return typeof v === "string";
  });

  if (shouldCollapseToString) {
    return values.map(String).join("");
  }

  var shouldCollapseToSingleValue = values.length === 1;

  if (shouldCollapseToSingleValue) {
    return values[0];
  }

  return values;
}

function toOutputValues(values) {
  var output = [];

  var _iterator4 = _createForOfIteratorHelper(values),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var v = _step4.value;

      if (typeof v === "string") {
        output.push(v);
      } else if (typeof v === "number") {
        output.push(String(v));
      } else if (isReactValue(v)) {
        var propsExcludingChildren = {};
        var children = void 0;
        var component = v.type,
            props = v.props;

        for (var _key3 in props) {
          if (props.hasOwnProperty(_key3)) {
            var value = collapseValues(toOutputValues(props[_key3]));

            if (_key3 === "children") {
              children = value;
            } else {
              propsExcludingChildren[_key3] = value;
            }
          }
        }

        if (children == null) {
          output.push(React.createElement(component, propsExcludingChildren));
        } else if (Array.isArray(children)) {
          output.push(React.createElement.apply(React, [component, propsExcludingChildren].concat(_toConsumableArray(children))));
        } else {
          output.push(React.createElement(component, propsExcludingChildren, children));
        }
      } else {
        output.push(v);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return output;
}

function evaluate(tokens, language, values, components) {
  var internalValues = evaluateToInternalValue(tokens, language, values, components, undefined);
  return toOutputValues(flatten(internalValues));
}

function localeToLanguage(locale) {
  locale = locale.toLowerCase();
  locale = locale.replace("_", "-");
  var parts = locale.split("-");

  if (parts.length > 0) {
    return parts[0];
  }

  return "";
}

var defaultValue = {
  locale: "en",
  language: "en",
  compile: function compile() {
    return [];
  },
  renderToString: function renderToString() {
    return "";
  }
};
var Context = React.createContext(defaultValue);
var Provider = Context.Provider,
    Consumer = Context.Consumer;
var LocaleProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleProvider, _React$Component);

  var _super = _createSuper(LocaleProvider);

  function LocaleProvider() {
    var _this;

    _classCallCheck(this, LocaleProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "tokensByID", {});

    _defineProperty(_assertThisInitialized(_this), "state", {
      version: 0
    });

    _defineProperty(_assertThisInitialized(_this), "compile", function (id) {
      var cachedTokens = _this.tokensByID[id];

      if (cachedTokens != null) {
        return cachedTokens;
      }

      var source = _this.props.messageByID[id];

      if (source == null) {
        throw new Error("expected \"".concat(id, "\" to exist"));
      }

      try {
        var tokens = parse(source);
        _this.tokensByID = _objectSpread2(_objectSpread2({}, _this.tokensByID), {}, _defineProperty({}, id, tokens));
        return tokens;
      } catch (e) {
        var message = e.message;
        e.message = "\"".concat(id, "\": ").concat(message);
        throw e;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderToString", function (id, values) {
      try {
        var _this$props = _this.props,
            locale = _this$props.locale,
            defaultComponents = _this$props.defaultComponents;

        var tokens = _this.compile(id);

        var language = localeToLanguage(locale);

        var components = _objectSpread2({}, defaultComponents);

        var result = evaluate(tokens, language, values || {}, components);
        var children = [];

        for (var i = 0; i < result.length; ++i) {
          var element = result[i];
          children.push( /*#__PURE__*/React.createElement(React.Fragment, {
            key: i
          }, element));
        }

        var tree = /*#__PURE__*/React.createElement(React.Fragment, null, children); // We cannot use renderToString because it adds extra attributes and HTML comments for hydrate().
        // See https://reactjs.org/docs/react-dom-server.html#rendertostaticmarkup

        var htmlString = renderToStaticMarkup(tree); // We cannot simply return htmlString because it is HTML and its content is escaped.
        // This also implies setting the result of renderToString as innerHTML is extremely unsafe!!!

        return decodeHTML5Strict(htmlString);
      } catch (e) {
        console.warn(e);
        return "";
      }
    });

    return _this;
  }

  _createClass(LocaleProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.locale !== prevProps.locale) {
        this.tokensByID = {};
        this.setState(function (prevState) {
          return {
            version: prevState.version + 1
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          locale = _this$props2.locale,
          children = _this$props2.children,
          defaultComponents = _this$props2.defaultComponents;
      return /*#__PURE__*/React.createElement(Provider, {
        value: {
          locale: locale,
          defaultComponents: defaultComponents,
          language: localeToLanguage(locale),
          compile: this.compile,
          renderToString: this.renderToString
        }
      }, children);
    }
  }]);

  return LocaleProvider;
}(React.Component);

function Message(props) {
  try {
    var _id = props.id,
        _values = props.values,
        ownComponents = props.components,
        defaultComponents = props.defaultComponents,
        language = props.language,
        compile = props.compile;
    var tokens = compile(_id);

    var components = _objectSpread2(_objectSpread2({}, defaultComponents), ownComponents);

    var result = evaluate(tokens, language, _values || {}, components);
    var children = [];

    for (var i = 0; i < result.length; ++i) {
      var element = result[i];
      children.push( /*#__PURE__*/React.createElement(React.Fragment, {
        key: i
      }, element));
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  } catch (e) {
    console.warn(e);
    return "";
  }
}

var FormattedMessage = /*#__PURE__*/function (_React$Component2) {
  _inherits(FormattedMessage, _React$Component2);

  var _super2 = _createSuper(FormattedMessage);

  function FormattedMessage() {
    var _this2;

    _classCallCheck(this, FormattedMessage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "renderMessage", function (contextValue) {
      return /*#__PURE__*/React.createElement(Message, _extends({}, _this2.props, contextValue));
    });

    return _this2;
  }

  _createClass(FormattedMessage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Consumer, null, this.renderMessage);
    }
  }]);

  return FormattedMessage;
}(React.Component);

export { Consumer, Context, FormattedMessage, LocaleProvider, evaluate, parse };
